import config from '../config/config.json'
import superagent from 'superagent'

const GET_ADMIN_USER_REQUEST = 'GET_ADMIN_USER_REQUEST'
const GET_ADMIN_USER_SUCCESS = 'GET_ADMIN_USER_SUCCESS'
const GET_ADMIN_USER_FAILURE = 'GET_ADMIN_USER_FAILURE'

export {
  GET_ADMIN_USER_REQUEST,
  GET_ADMIN_USER_SUCCESS,
  GET_ADMIN_USER_FAILURE
}

export function getAdminUserRequest() {
  return {
    type: GET_ADMIN_USER_REQUEST,
    loading: true
  }
}

export function getAdminUserSuccess(body) {
  return {
    type: GET_ADMIN_USER_SUCCESS,
    body: body,
    loading: false
  }
}

export function getAdminUserFailure(error) {
  return {
    type: GET_ADMIN_USER_FAILURE,
    error: error,
    loading: false
  }
}

export function getAdminUser(body, cb) {
  return function(dispatch) {
    dispatch(getAdminUserRequest())
    superagent
    .get(config.BASE + 'api/admin/users')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert(JSON.stringify(err.response.body.message))
        dispatch(getAdminUserFailure(err))
      } else {
        dispatch(getAdminUserSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const UPDATE_ADMINUSER_INPUT = 'UPDATE_ADMINUSER_INPUT'

export { UPDATE_ADMINUSER_INPUT }

export function updateAdminUserInput(key, value) {
  return {
    type: UPDATE_ADMINUSER_INPUT,
    key: key,
    value: value
  }
}



// WEBPACK FOOTER //
// ./src/actions/AdminUser.js